<div class="relative flex flex-col items-center justify-center w-full h-full bg-dashboard-dark text-white overflow-hidden">
  <app-background-lines></app-background-lines>

  <!-- Main Content -->
  <div class="relative z-10 flex flex-col items-center justify-center flex-1 gap-6 sm:gap-8 md:gap-10 w-full px-6 sm:px-8">
    <!-- Current Group Section -->
    <div class="text-center">
      <h3 class="text-xs sm:text-sm md:text-base lg:text-lg font-light tracking-[0.3em] uppercase mb-4 sm:mb-6 text-white/50">
        Current Group
      </h3>

      <div class="h-auto">
        <h1 class="text-[140px] sm:text-[160px] md:text-[180px] lg:text-[220px] font-black tracking-tighter leading-none">
          {{ currentGroup() }}
        </h1>
      </div>

      <p class="text-xs sm:text-sm md:text-base lg:text-lg tracking-widest text-white/60 mt-4">
        {{ shiftSchedule().start }} — {{ shiftSchedule().end }}
      </p>
    </div>

    <!-- Shift Details Grid -->
    <div class="grid grid-cols-3 gap-6 sm:gap-10 md:gap-14 lg:gap-20 w-full max-w-3xl mt-4">
      <!-- Outgoing Group -->
      <div class="text-center">
        <p class="text-[9px] sm:text-[10px] md:text-xs lg:text-sm font-light tracking-[0.2em] uppercase text-white/40 mb-2 sm:mb-3">
          Outgoing Group
        </p>
        <p class="text-base sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white">
          {{ currentGroup() }}
        </p>
      </div>

      <!-- Incoming Group -->
      <div class="text-center">
        <p class="text-[9px] sm:text-[10px] md:text-xs lg:text-sm font-light tracking-[0.2em] uppercase text-white/40 mb-2 sm:mb-3">
          Incoming Group
        </p>
        <p class="text-base sm:text-2xl md:text-3xl lg:text-4xl font-bold text-green-400">
          {{ incomingGroup }}
        </p>
      </div>

      <!-- Next Change -->
      <div class="text-center">
        <p class="text-[9px] sm:text-[10px] md:text-xs lg:text-sm font-light tracking-[0.2em] uppercase text-white/40 mb-2 sm:mb-3">
          Next Change
        </p>
        <p class="text-base sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white">
          {{ shiftSchedule().end }}
        </p>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="w-full max-w-2xl mt-6 sm:mt-8">
      <div class="w-full h-1 sm:h-1.5 bg-white/20 rounded-full overflow-hidden">
        <div class="h-full transition-all duration-1000" [style.width.%]="progressPercent()" [style.backgroundColor]="'#22c55e'"></div>
      </div>
    </div>

    <!-- Time Remaining -->
    <p class="text-xs sm:text-sm md:text-base text-white/60 tracking-wide mt-4">
      {{ timeRemaining() }} until shift change
    </p>
  </div>
</div>